export function filterOutEmptyFields<T>(obj: T): T {
  const newObj = {} as T;
  for (const key in obj) {
    if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') {
      newObj[key] = obj[key];
    }
  }
  return newObj;
}
